import { HTTPError } from "../../util/CustomErrors";
export class ParserError extends HTTPError {
    mJSONOutput;
    constructor(statusCode, message, url, jsonOutput) {
        super(statusCode, message, url);
        this.name = this.constructor.name;
        this.mJSONOutput = jsonOutput;
    }
    get JSONOutput() {
        return this.mJSONOutput;
    }
}
